import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Footer from "../landingPage/footer";
import { Layout } from "antd";
import MetaTagContents from "../../MetaTagContents";
import DarkNavbar from "../landingPage/header/DarkNavbar";
import HeroSection from "./HeroSection/HeroSection";
import "./Homepage.scss";
import FeaturedInArticles from "./FeaturedInArticles/FeaturedInArticles";
import RealResults from "./RealResults/RealResults";
import Metrics from "../SMBLandingPage/Metrics/Metrics";
import GetStarted from "./GetStarted/GetStarted";
import OfferingCarousel from "./OfferingCarousel/OfferingCarousel";
import ProductCreationProcess from "./ProductCreationProcess/ProductCreationProcess";
import HomepageServices from "./HomepageServices/HomepageServices";
import DiscordSection from "./DiscordSection/DiscordSection";
import { trackCta } from "../../analytics";

const Homepage = () => {
    const { name, content, schemaMarkup } = MetaTagContents.LANDING_PAGE;
    // Superseded by marketing.js captureMarketingContext, which persists all
    // 5 UTMs (not just utm_source) on every route change. Kept for reference.
    // const url = new URL(window.location.href);
    // const utm_source = url.searchParams.get('utm_source');
    // if (utm_source) {
    //     localStorage.setItem('utm_source', utm_source);
    // }

    useEffect(() => {
        trackCta('homepage_visit', {});
    }, []);

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{MetaTagContents.LANDING_PAGE.title}</title>
                <link rel="canonical" href="https://all3d.ai/" />
                <meta name={name} content={content} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup.video)}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup.organization)}
                </script>
            </Helmet>
            <DarkNavbar />
            <Layout className="top-margins">
                <HeroSection />
                <FeaturedInArticles />
                <OfferingCarousel />
                <ProductCreationProcess />
                <HomepageServices />
                <RealResults />
                <Metrics />
                <GetStarted />
                <DiscordSection />
            </Layout>
            <Footer />
        </>
    );
};

export default Homepage;
